document.addEventListener('DOMContentLoaded', () => {
    // Tabs
    const tabs = document.querySelectorAll('.faq-tab');
    const items = document.querySelectorAll('.faq-item');
     function filterTabs(category) {
        items.forEach(item => {
        item.classList.remove('active');
        item.querySelector('.faq-answer').style.height = '0px';

        if (item.dataset.category === category) {
            item.style.display = 'block';
        } else {
            item.style.display = 'none';
        }
        });
    }
    tabs.forEach(tab => {
    tab.addEventListener('click', () => {
        const category = tab.dataset.tab;

        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        items.forEach(item => {
        item.classList.remove('active');
        item.querySelector('.faq-answer').style.height = '0px';

        if (item.dataset.category === category) {
            item.style.display = 'block';
        } else {
            item.style.display = 'none';
        }
        });
    });
    });
    // Accordion
    document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
        const item = btn.closest('.faq-item');
        const content = item.querySelector('.faq-answer');
        const isOpen = item.classList.contains('active');

        // close others
        document.querySelectorAll('.faq-item').forEach(i => {
        if (i !== item) {
            i.classList.remove('active');
            i.querySelector('.faq-answer').style.height = '0px';
        }
        });

        if (isOpen) {
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
            content.style.height = '0px';
        });
        item.classList.remove('active');
        } else {
        item.classList.add('active');
        content.style.height = content.scrollHeight + 'px';
        }
    });
    });
     const activeTab = document.querySelector('.faq-tab.active');
    if (activeTab) {
        filterTabs(activeTab.dataset.tab);
    }
});